import React, { useEffect, useState } from "react";

import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

import { showContracts, updateContracts } from "../../../../MyApi/hr/contracts";

import PageHeader from "../../../../Components/UI/PageHeader";
import EditConstracts from "../../../../Components/hr/constracts/constractsUpdate/EditConstracts";
import LoadingSpinner from "../../../../Components/UI/spinner";

const ConstractsUpdate = () => {
  const [sb_company_id, setCompanyId] = useState("");
  const [hr_designation_id, setHr_designation_id] = useState("");
  const [sb_branch_id, setBranchId] = useState("");
  const [sb_department_id, setDepartmentId] = useState("");
  const [sb_employe_id, setEmployId] = useState("");
  const [hr_level_id, setLevelId] = useState("");
  const [sb_currency_id, setCurrencyId] = useState("");
  const [description, setDescription] = useState("");
  const [active, setActive] = useState(1);
  const [start_date, setStart_date] = useState("");
  const [duration, setDuration] = useState("");
  const [duration_type, setDurationType] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [join_date, setJoin_date] = useState("");
  const [signing_date, setSigningDate] = useState("");
  const [intership, setInterShip] = useState(1);
  const [internship_end_date, setInterShipEndDate] = useState("");
  const [paid_period, setPaidPeriod] = useState("");
  const [status, setStatus] = useState("");
  const [salaryComponentObject, setSalaryComponentObject] = useState({});
  const [total, setTotal] = useState(0);
  const [rows, setRows] = useState([]);
  const [selectedLangCode, setSelectedLangCode] = useState("");
  const { id } = useParams();
  const { data, isLoading } = useQuery(["showcontracts", id], () =>
    showContracts(id)
  );

  const contracts = data?.data || [];

  useEffect(() => {
    setCompanyId(contracts.sb_company_id);
    setHr_designation_id(contracts.hr_designation_id);
    setBranchId(contracts.sb_branch_id);
    setDepartmentId(contracts.sb_department_id);
    setEmployId(contracts.sb_employe_id);
    setLevelId(contracts.hr_level_id);
    setCurrencyId(contracts.sb_currency_id);
    setDescription(contracts.description);
    setActive(contracts.active);
    setStart_date(contracts.start_date);
    setDuration(contracts.duration);
    setDurationType(contracts.duration_type);
    setEnd_date(contracts.end_date);
    setStatus(contracts.status);
    setInterShip(contracts.intership);
    setJoin_date(contracts.join_date);
    setSigningDate(contracts.signing_date);
    setInterShipEndDate(contracts.internship_end_date);
    setPaidPeriod(contracts.paid_period);
    setTotal(contracts.total);
    setRows(contracts.salaries || []);
  }, [contracts]);

  const mutation = useMutation(
    ["updateconstracts", id, selectedLangCode],
    (postData) => updateContracts(postData, id, selectedLangCode),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );
  let hr_salary_component_ids = [];
  let amounts = [];

  const handleAddRow = () => {
    setRows([...rows, { id: rows.length + 1 }]);
  };
  const handleRemoveRow = (RowId) => {
    setRows(rows.filter((row) => row.id !== RowId));
    setSalaryComponentObject({
      ...salaryComponentObject,
      [RowId]: null,
    });
  };

  rows.forEach((item) => {
    if (item !== null) {
      hr_salary_component_ids.push(item.id);
      amounts.push(item.amount);
    }
  });
  const handlePostRequest = () => {
    mutation.mutate({
      sb_company_id,
      active,
      hr_designation_id,
      hr_level_id,
      start_date,
      duration,
      duration_type,
      end_date,
      join_date,
      signing_date,
      intership,
      internship_end_date,
      paid_period,
      status,
      hr_salary_component_ids,
      amounts,
      sb_currency_id,
      total,
      sb_employe_id,
      sb_branch_id,
      sb_department_id,
      lang_code: selectedLangCode,
    });
  };
  const isDisabled = () => {
    return false;
  };
  const onSelectChange = (e) => {
    setSelectedLangCode(e.target.value);
  };
  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!data) {
    return <div>no data available</div>;
  }
  return (
    <div>
      <PageHeader
        title="Edit Constracts"
        showSelect
        onSelectChange={onSelectChange}
        showBack={true}
        saveButton={true}
        isdisbled={isDisabled}
        handlePostRequest={handlePostRequest}
      />
      <EditConstracts
        desgnationId={hr_designation_id}
        levelId={hr_level_id}
        setRows={setRows}
        total={total}
        paidPeriod={paid_period}
        status={status}
        duration_type={duration_type}
        companyId={sb_company_id}
        branchId={sb_branch_id}
        employId={sb_employe_id}
        departmentId={sb_department_id}
        currencyId={sb_currency_id}
        setEmployId={setEmployId}
        signing_date={signing_date}
        join_date={join_date}
        end_date={end_date}
        duration={duration}
        start_date={start_date}
        description={description}
        intership={intership}
        handleRemoveRow={handleRemoveRow}
        salaryComponentObject={salaryComponentObject}
        setDepartmentId={setDepartmentId}
        handleAddRow={handleAddRow}
        rows={rows}
        setTotal={setTotal}
        setBranchId={setBranchId}
        setCurrencyId={setCurrencyId}
        setSalaryComponentObject={setSalaryComponentObject}
        setPaidPeriod={setPaidPeriod}
        setStatus={setStatus}
        setJoin_date={setJoin_date}
        setSigningDate={setSigningDate}
        setInterShipEndDate={setInterShipEndDate}
        setInterShip={setInterShip}
        setHr_designation_id={setHr_designation_id}
        setLevelId={setLevelId}
        setStart_date={setStart_date}
        setCompanyId={setCompanyId}
        setDescription={setDescription}
        setActive={setActive}
        active={active}
        setDuration={setDuration}
        setDurationType={setDurationType}
        setEnd_date={setEnd_date}
      />
    </div>
  );
};

export default ConstractsUpdate;
